import React from "react";
import MainLayout from "../../layout/MainLayout";
import styled from "styled-components";
import Hero from "../../components/hero/Hero";
import CardService from "../../components/cards/CardService";

const ServicesContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: #f9f9f9;
  padding: 40px;
`;

const Title = styled.h2`
  font-size: 2rem;
  margin-bottom: 10px;
  font-weight: bold;
  color: #041c40;
  text-align: center;
  font: normal normal bold 60px / 53px;
`;

const Divider = styled.div`
  width: 100px;
  height: 3px;
  background-color: #f7bc0c;
  margin: 0 auto 30px;
`;

const cardData = [
  {
    title: "FINISH CARPENTRY",
    description:
      "Precision-crafted details to elevate your spaces. Our expert carpenters deliver flawless trim work, crown molding, and custom finishes to bring your vision to life.",
      image: "./img/services/service1.jpg",
  },
  {
    title: "ROOFING & SIDING",
    description:
      "Durable and stylish protection for your home. We specialize in roofing and siding solutions that combine functionality with aesthetic appeal, tailored to withstand the elements.",
    image: "./img/services/service2.jpg",
  },
  {
    title: "FRAMING RENOVATIONS",
    description:
      "Building the backbone of your dreams. From structural adjustments to complete framing projects, our team ensures strength and stability for every renovation.",
    image: "./img/services/service3.jpg",
  },
  {
    title: "ADDITIONS",
    description:
      "Expand your living space seamlessly. Whether it's a new room, garage, or sunroom, our additions blend beautifully with your existing home.",
    image: "./img/services/service4.jpg",
  },
  {
    title: "DECKS",
    description:
      "Create your outdoor oasis. From sleek designs to sturdy builds, we construct decks that are perfect for entertaining, relaxing, or enjoying the view.",
    image: "./img/services/service5.jpg",
  },
  {
    title: "OTHER",
    description:
      "Tailored solutions for every unique need. From custom projects to specialized requests, we tackle a wide variety of services with quality craftsmanship.",
    image: "./img/services/service6.jpg",
  },
];

const Services = () => {
  return (
    <MainLayout>
      <div>
        <Hero title={"Services"} />
      </div>
      <ServicesContainer>
        <Title>Our Services</Title>
        <Divider />
        <CardService cardData={cardData}/>
      </ServicesContainer>
    </MainLayout>
  );
};

export default Services;
